<template>
  <b-row class="m-0">
    <b-col md="6" sm="12" v-if="period_context_loaded" class="text-base pr-2 pb-4 pl-2">
      <b-container fluid style="height: auto; min-height: 245px" class="white-box">
        <b-row align-h="center" class="mt-2 mr-0 mb-4">
          Receita
        </b-row>



        <b-row class="receipt-justify m-0 mb-4">
        <b-col md='12' lg='12' class="text-14 mb-3">
        <b-row align-v="start" class="receipt-justify">
         <a class="custom-link text-left display-flex-span" :href="url_order_paid_orders + selectedPeriod" target="_blank">
          <span class="text-30">{{ total_order_paid }} <b class="text-14" style="vertical-align: middle;">({{ total_paid_orders_count }} pagos)</b></span>
          </a>
          </b-row>
        </b-col>
        </b-row>
        <b-row>
          <b-col md='12' lg='4' class="text-14 mb-3">
            <b-row align-v="start" class="receipt-justify">
            <div :class="'bullet-box mr-2 mt-1  gb'"></div>
            <a class="custom-link text-left display-flex-span" :href="url_order_current_period + selectedPeriod" target="_blank">
              <span>{{ total_bucket }}&nbsp;</span>
              <span class="text-12">(total de pedidos: {{ total_orders_count }})</span>
            </a>
            </b-row>

          </b-col>
          <b-col v-for="(obj, i) in PaymentsInfoObject_1" :key="'obj-1-' + i" lg="4" md="12" class="text-14 mb-3">
            <b-row align-v="start" class="receipt-justify">
              <div :class="'bullet-box mr-2 mt-1 ' + obj.bg"></div>
              <a class="custom-link text-left display-flex-span" :href="obj.url + selectedPeriod" target="_blank">
                <span>{{ obj.info }}&nbsp;</span>
                <span class="text-12">({{ obj.count }} {{ obj.label }})</span>
              </a>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-col>
    <b-col v-else md="6" sm="12" class="pr-2 pb-4 pl-2">
      <loader-box height="192px"/>
    </b-col>

    <b-col md="6" sm="12" v-if="period_context_loaded" class="text-base pr-2 pb-4 pl-2">
      <b-container fluid style="height: auto; min-height: 245px" class="white-box">
        <b-row class="mt-2 mr-0 mb-4 ml-0">
          Pedidos por método:
        </b-row>

        <b-row class="m-0">
          <b-col md="3" sm="12" v-for="(obj, index) in PaymentsInfoObject_2" :key="'obj-2-' + index" class="pl-0 mb-3">
            <b-row class="m-0 mb-2">
              <b-col md sm="2" cols="3" style="max-width: fit-content;" class="pl-0 text-left">
                <img :src="require(`@/assets/${obj.img}`)" alt="img">
              </b-col>
              <b-col class="line-height-1 margin-methods">
                <b-row class="text-14">{{ obj.info }}</b-row>
                <b-row class="text-12">
                  <a class="custom-link" :href="obj.url + selectedPeriod" target="_blank">{{ obj.url_label }}</a>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-for="(item, i) in obj.array" :key="'obj-2-' + i" class="align-items-center text-14 m-0 mb-2">
              <div :class="'bullet-box ' + item.bg"></div>
              <a class="custom-link" :href="item.url + selectedPeriod" target="_blank">{{ item.info }}</a>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-col>
    <b-col v-else md="6" sm="12" class="pr-2 pb-4 pl-2">
      <loader-box height="192px"/>
    </b-col>
  </b-row>
</template>

<script>
import LoaderBox from '@/components/LoaderBox.vue'

export default {
  components: {
    LoaderBox
  },
  computed: {
    period_context_loaded() { return this.$store.getters.period_context_loaded },
    orderPeriodSelectedIndex() { return this.$store.getters.orderPeriodSelectedIndex },
    total_bucket () { return this.$store.getters.total_bucket },
    total_orders_count () { return this.$store.getters.total_orders_count },
    total_order_paid() { return this.$store.getters.total_order_paid },
    total_paid_orders_count() { return this.$store.getters.total_paid_orders_count },
    url_order_paid_orders() { return this.$store.getters.url_order_paid_orders },
    url_order_current_period () { return this.$store.getters.url_order_current_period },
    PaymentsInfoObject_1() { return this.$store.getters.PaymentsInfoObject_1 },
    PaymentsInfoObject_2() { return this.$store.getters.PaymentsInfoObject_2 },

    selectedPeriod() {
      switch (this.orderPeriodSelectedIndex) {
        case 0:
          return '&date_period=1'
        case 1:
          return '&date_period=2'
        case 2:
          return '&date_period=3'
        case 3:
          return '&date_period=4'
        case 4:
          return '&date_period=6'
        case 5:
          return '&date_period=7'
        case 6:
          return 'date_period=8'
      }
      return ''
    }
  }
}
</script>

<style scoped>
  @media only screen and (min-width: 768px) {
    .receipt-justify {
      justify-content: center;
    }
    .break-label-card {
      width: 100%;
      display: inline-block;
    }
    .margin-methods {
      margin-bottom: 1.25rem !important;
    }
  }

  @media only screen and (max-width: 768px) {
    .receipt-justify {
      margin-left: 0.25rem !important;
    }
  }

  @media only screen and (min-width: 992px) {
    .display-flex-span {
      display: flex;
      flex-direction: column;
    }
  }

  @media only screen and (max-width: 992px) {
    .display-flex-span {
      display: flex;
      flex-direction: row !important;
    }
  }
</style>
